import { MutationTree } from 'vuex'

import { AppState } from './types'

const mutations: MutationTree<AppState> = {
  setSearchParams: (state, searchParams) => {
    state.data.searchParams = searchParams
  }
}

export default mutations
